import {
  ClientsProjectInvoicesAuditProps,
  GetClientInvoiceAudit,
  InvoiceAuditProps,
  ProjectAuditProps,
  ProjectInvoiceDetails,
  clients,
  GetAllResults,
  inVoiceSummary,
} from '../../../../types/Invoicing/ClientInvoiceReport/ClientInvoiceReportTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, clientInvoiceReportApiConfig } from '../../apiList'

const getClientInvoiceAudit = async (
  props: InvoiceAuditProps,
): Promise<GetClientInvoiceAudit> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: clientInvoiceReportApiConfig.clientInvoiceAudit,
    method: AllowedHttpMethods.get,
    params: {
      fromDate: props.fromDate,
      multiText: props.multiText as string,
      pendingAmountFlag: props.pendingAmountFlag,
      selectionStatus: props.selectionStatus,
      toDate: props.toDate,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getClientsProjectsAudit = async (
  props: ProjectAuditProps,
): Promise<GetAllResults> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: clientInvoiceReportApiConfig.clientsProjectsAudit,
    method: AllowedHttpMethods.get,
    params: {
      clientId: props.clientId,
      displayEndDate: props.displayEndDate,
      displayStartDate: props.displayStartDate,
      pendingAmountFlag: props.pendingAmountFlag,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getClientsProjectInvoicesAudit = async (
  props: ClientsProjectInvoicesAuditProps,
): Promise<ProjectInvoiceDetails> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: clientInvoiceReportApiConfig.clientsProjectInvoicesAudit,
    method: AllowedHttpMethods.get,
    params: {
      projectId: props.projectId,
      displayEndDate: props.displayEndDate,
      displayStartDate: props.displayStartDate,
      pendingAmountFlag: props.pendingAmountFlag,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getInvoiceSummary = async (
  invoiceId: number,
): Promise<inVoiceSummary> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: clientInvoiceReportApiConfig.getInvoiceSummary,
    method: AllowedHttpMethods.get,
    params: {
      invoiceId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getClients = async (): Promise<clients[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: clientInvoiceReportApiConfig.getClients,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const clientInvoiceReportApi = {
  getClients,
  getClientInvoiceAudit,
  getClientsProjectsAudit,
  getClientsProjectInvoicesAudit,
  getInvoiceSummary,
}
export default clientInvoiceReportApi
